import {createSvgIcon} from '../create-svg-icon';

export const HorizontalRuleIcon = createSvgIcon(
  <path fillRule="evenodd" d="M4 11h16v2H4z" />
, 'HorizontalRuleOutlined');
